module.exports = __webpack_public_path__ + "img/image10.bce1aa0b.png";